import { Region } from 'constants/shop';
import { COLLECTION_HANDLES, CollectionHandleKey } from '../handles';
import { CollectionHandles } from '../types';

/** Without a catalog the key is a page handle key; with one it is a key of that catalog. */
type GetHandleInput<T extends CollectionHandles> =
  | { key: CollectionHandleKey; region?: Region; handles?: undefined }
  | { key: keyof T & string; region?: Region; handles: T }; // in case we pass handles dictionary as argument

export const getHandle = <T extends CollectionHandles>(input: GetHandleInput<T>): string => {
  const { key, region = Region.DE, handles } = input;
  // Widened to the shared shape: the literal-keyed catalogs cannot be indexed by a generic key.
  const catalog: CollectionHandles = handles ?? COLLECTION_HANDLES;
  const entry = catalog[key];
  const result = entry?.[region] || entry?.[Region.DE];

  if (!result) {
    throw new Error(`Collection handle not found for key: ${key} and region: ${region}`);
  }

  return result;
};
